import ResourceInput from './ResourceInput';

export default ResourceInput;
